import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  drawer: {
    '& .MuiDrawer-paper': {
      display: 'block',
      height: '100%',
      width: '364px',
      overflow: 'hidden',
    },
  },
  sectionContainer: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100vh',
    backgroundColor: '#FFFFFF',
    zIndex: 10,
  },
  title: {
    position: 'relative',
    padding: '16px 24px 24px',
    backgroundColor: '#FFFFFF',
  },
  closeIcon: {
    cursor: 'pointer',
  },
  filterSection: {
    zIndex: 1,
    width: '364px',
    backgroundColor: '#FFFFFF',
    cursor: 'pointer',
    padding: '16px 24px 24px',
  },
  sectionTitle: {
    height: '60px',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '#D6DADC 1px solid',
    backgroundColor: '#FFFFFF',
    zIndex: 1,
  },
  backButton: {
    cursor: 'pointer',
  },
  checkboxContainer: {
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingBottom: '24px',
    position: 'absolute',
    overflow: 'auto',
    top: 60,
    bottom: 84,
    height: 'calc(100% - 250px)',
  },
  pillsContainer: {
    marginTop: '2px',
  },
  actionContainer: {
    position: 'relative',
    bottom: 0,
    borderTop: '#D6DADC 1px solid',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    backgroundColor: '#FFFFFF',
    height: '84px',
    padding: '24px 17px',
    zIndex: 15,
    '& > button:first-child': {
      marginRight: '8px',
    },
  },
  filterWrapper: {
    backgroundColor: '#FFFFFF',
    height: 'calc(100% - 156px)',
    width: '100%',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { display: 'none' }, // Hide scrollbar for Chrome, Safari and Opera
    '-ms-overflow-style': 'none', // Hide scrollbar for IE and Edge
    scrollbarWidth: 'none', // Hide scrollbar for Firefox
  },
  filterButton: {
    marginRight: '10px',
  },
  onlyOfficeAddressContainer: {
    display: 'flex',
    padding: '22px 24px',
    borderBottom: '#D6DADC 1px solid',
  },
  onlyOfficeAddressText: {
    marginLeft: '8px',
    fontSize: '14px',
    fontWeight: 400,
    [theme.breakpoints.down(960)]: {
      position: 'relative',
      top: '1px',
    },
    [theme.breakpoints.down(600)]: {
      top: '2px',
    },
  },
  onlyOfficeAddressTooltip: {
    position: 'relative',
    top: '-1.5px',
    marginLeft: '2px',
    transform: 'scale(0.7)',
  },
}));
